"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_1 = require("react");
const react_final_form_1 = require("react-final-form");
const components_1 = require("components");
const logo_alphaeon_access_svg_1 = __importDefault(require("images/lenders/logo-alphaeon-access.svg"));
const components_2 = require("../../components");
const FieldsBanking_1 = __importDefault(require("./FieldsBanking"));
const FieldsPaymentFrequency_1 = __importDefault(require("./FieldsPaymentFrequency"));
const FieldsWisconsin_1 = __importDefault(require("./FieldsWisconsin"));
const TermsAgreementShell_1 = __importDefault(require("./TermsAgreementShell"));
const validate_1 = require("./utils/validate");
const PreQualAccessForm = ({ submitFunc, isSubmitting, onSubmitFail, submitButtonText, lenderName, onSubmitSuccess, locationId, personalInfo, prequalification, }) => {
    const paymentFrequencyRef = (0, react_1.useRef)(null);
    const bankingDetailsRef = (0, react_1.useRef)(null);
    const wisconsinDetailsRef = (0, react_1.useRef)(null);
    const lenderProps = (0, react_1.useMemo)(() => {
        let tmpLogo = '';
        let tmpDesc = '';
        let tmpNick = '';
        const noFieldsToShow = false;
        let formValidate = (values) => {
            if (Object.keys(values).length) {
                const errors = {};
                return errors;
            }
            else {
                return undefined;
            }
        };
        switch (lenderName) {
            case 'AFF':
                tmpLogo = logo_alphaeon_access_svg_1.default;
                tmpDesc = 'American First Finance';
                tmpNick = 'AFF';
                formValidate = validate_1.validateAFF;
                break;
            default:
                break;
        }
        return {
            logo: tmpLogo,
            desc: tmpDesc,
            nick: tmpNick,
            formValidate: formValidate,
            noFieldsToShow: noFieldsToShow,
        };
    }, [lenderName]);
    // Func submit form
    const formSubmit = async (values) => {
        const isFormValid = lenderProps.formValidate(values);
        if (isFormValid === undefined) {
            const res = await submitFunc({
                lender_required_params: {
                    ...values,
                    tcpa_consent: values.termsAgreedTo1 && values.termsAgreedTo1.length > 0
                        ? true
                        : false,
                    income_pay_next: values.income_pay_next
                        ? (0, date_fns_1.format)((0, date_fns_1.parse)(values.income_pay_next, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd')
                        : undefined,
                    income_pay_last: values.income_pay_last
                        ? (0, date_fns_1.format)((0, date_fns_1.parse)(values.income_pay_last, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd')
                        : undefined,
                },
            });
            if (res) {
                onSubmitSuccess(res);
            }
            else {
                onSubmitFail('Sorry, there was an error submitting the form');
            }
        }
    };
    const financedAmount = (0, react_1.useMemo)(() => prequalification.offers.filter((offer) => {
        return offer.serviceProviderName === 'AFF';
    })[0]?.amount, [prequalification]);
    const isLTO = prequalification.offers.some((offer) => offer.lenderProductType === 'LTO');
    const incomeFrequencyValuesMap = {
        W: 'weekly',
        B: 'bi_weekly',
        M: 'monthly',
        T: 'semi_monthly',
    };
    const errorToRefMap = {
        income_frequency: paymentFrequencyRef,
        stateCode: wisconsinDetailsRef,
        income_pay_next: paymentFrequencyRef,
        income_pay_last: paymentFrequencyRef,
        account_aba_number: bankingDetailsRef,
        account_number: bankingDetailsRef,
        bank_name: bankingDetailsRef,
        married: wisconsinDetailsRef,
        spouse_live_with: wisconsinDetailsRef,
        address_spouse_state: wisconsinDetailsRef,
        spouse_name: wisconsinDetailsRef,
        address_spouse_line1: wisconsinDetailsRef,
        address_spouse_line2: wisconsinDetailsRef,
        address_spouse_city: wisconsinDetailsRef,
        address_spouse_zip: wisconsinDetailsRef,
    };
    const handleScrollToError = (errorKey) => {
        if (!errorKey.includes('termsAgreedTo')) {
            errorToRefMap[errorKey]?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { className: "pre-qualification-installment", children: (0, jsx_runtime_1.jsx)("div", { className: "form-shell", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: {}, onSubmit: formSubmit, validate: lenderProps.formValidate, render: ({ handleSubmit, pristine, submitting, values, hasValidationErrors, errors, form, }) => {
                        // Button Disabled Bool
                        const btnDisabled = (pristine && !lenderProps.noFieldsToShow) ||
                            submitting ||
                            hasValidationErrors;
                        const buttonText = submitting ? '...Submitting' : submitButtonText;
                        return ((0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, children: [lenderName === 'AFF' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldsPaymentFrequency_1.default, { values: values, ref: paymentFrequencyRef }), (0, jsx_runtime_1.jsx)(components_2.AccessOfferEstimate, { isLTO: isLTO, applicationId: prequalification.applicationId, financedAmount: financedAmount, paymentFrequency: incomeFrequencyValuesMap[values.income_frequency] ?? '' }), (0, jsx_runtime_1.jsx)(FieldsBanking_1.default, { ref: bankingDetailsRef, routingNumber: values.account_aba_number ?? '', form: form }), personalInfo.state === 'WI' ? ((0, jsx_runtime_1.jsx)(FieldsWisconsin_1.default, { personalInfo: personalInfo, ref: wisconsinDetailsRef })) : null, (0, jsx_runtime_1.jsx)(TermsAgreementShell_1.default, { locationId: locationId, lenderName: lenderName })] })) : null, (0, jsx_runtime_1.jsxs)("div", { className: "send-receipt-buttons pad-40", children: [(0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", "data-testid": "access-form-submit-button", className: `send-receipt-modal-btn button-primary button-warn ${btnDisabled ? 'is-disabled' : 'is-enabled'} ${submitting || isSubmitting ? 'in-progress' : ''}`, invalid: btnDisabled && !(pristine || isSubmitting || submitting), disabledToolTip: "Please fill out all required fields and correct any validation errors.", children: buttonText }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), !pristine && hasValidationErrors && errors
                                            ? Object.keys(errors).map((errorKey, index) => ((0, jsx_runtime_1.jsxs)("span", { className: "error-message clickable-el", tabIndex: 0, role: "button", onClick: () => handleScrollToError(errorKey), onKeyDown: (e) => {
                                                    if (e.key === 'Enter') {
                                                        handleScrollToError(errorKey);
                                                    }
                                                }, children: [errors[errorKey], Object.keys(errors).length !== index + 1
                                                        ? ','
                                                        : '', "\u00A0"] }, errorKey)))
                                            : null, (0, jsx_runtime_1.jsx)("br", {})] }), (0, jsx_runtime_1.jsxs)(components_1.P, { children: [(0, jsx_runtime_1.jsx)("sup", { children: "\u2020" }), " \u00A0 While this amount is requested, please note that some providers do not take the Intended Transaction Amount into account for their decision."] })] }));
                    } }) }) }, `prequal-form`) }));
};
exports.default = PreQualAccessForm;
